import { Availability } from '../../domain/Availability'
import { BookingReason } from '../../domain/BookingReason'
import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    TemplateRef,
} from '@angular/core'
import { FormGroup } from '@angular/forms'

@Component({
    selector: 'app-reason-selection',
    templateUrl: './reason-selection.component.html',
})
export class ReasonSelectionComponent implements OnChanges {

    @Input() availability!: Availability
    @Input() form!: FormGroup
    @Input() isLoading!: boolean
    @Input() noAvailability!: TemplateRef<any>
    @Output() reasonSelected = new EventEmitter<BookingReason>()
    @Output() joinWaitlistRequested = new EventEmitter<void>()
    hasReasonsFittingPartySize = false
    reasonsAtIdealTime: { reason: BookingReason; isFull: boolean }[] = []
    reasonsOutsideIdealTime: { reason: BookingReason; isFull: boolean }[] = []
    hasReasonsOutsideIdealTimeRange = false
    numberOfReasonsOutsideIdealTimeRange = 0
    someReasonsHaveMaxPartySizeAndLargePartyNoAvailabilityMessage = false
    shouldShowReasonSelection = false
    selectedReason: BookingReason | null = null
    showValidationError = false
    reasonPluralMapping = {
        '=1': 'There is one reason',
        other: 'There are # reasons',
    }

    ngOnChanges(changes: SimpleChanges) {
        this.hasReasonsFittingPartySize = this.availability.doesConfigurationHaveAnyReservableReasons(
            this.form.get('partySize')?.value,
            this.form.get('idealTime')?.value
        )
        const idealTime = this.form.get('idealTime')?.value
        const allReasons = this.availability.venue.reasonsUsedOnDate(idealTime)
        this.reasonsAtIdealTime = allReasons
        .filter(reason => {
            return this.availability.venue.reasonsUsedOnDateTime(idealTime)
            .some(idealReason => idealReason.id === reason.id)
        })
        .map(reason => {
            return {
                reason: reason,
                isFull: this.availability.hasReasonReachedLimit(
                    reason,
                    this.form.get('partySize')?.value
                )
            }
        })
        this.reasonsOutsideIdealTime = allReasons
            .filter(reason => !this.reasonsAtIdealTime.some(idealReason => idealReason.reason.id === reason.id))
            .map(reason => {
                return {
                    reason: reason,
                    isFull: this.availability.hasReasonReachedLimit(
                        reason,
                        this.form.get('partySize')?.value
                    )
                }
            })
        const hasRestrictedReasons = allReasons.length !== this.reasonsAtIdealTime.length
        this.hasReasonsOutsideIdealTimeRange = hasRestrictedReasons
        this.numberOfReasonsOutsideIdealTimeRange = allReasons.length - this.reasonsAtIdealTime.length
        this.someReasonsHaveMaxPartySizeAndLargePartyNoAvailabilityMessage = 
            allReasons.some(reason => {
                return reason.maximumPartySize !== null &&
                    reason.largePartyNoAvailabilityMessage !== null
            })
        const selectedAreaId = this.form.get('selectedAreaId')?.value ?? null
        const hasExceptionNoAvailabilityDescription = this.availability.exceptionNoAvailabilityDescription(selectedAreaId) !== null
        this.shouldShowReasonSelection = !hasExceptionNoAvailabilityDescription &&
            (
                this.hasReasonsFittingPartySize ||
                this.someReasonsHaveMaxPartySizeAndLargePartyNoAvailabilityMessage
            )
    }

    next() {
        if (this.selectedReason) {
            this.form.get('selectedReasonId')?.setValue(this.selectedReason.id)
            this.form.get('selectedReasonId')?.markAsDirty()
            this.reasonSelected.emit(this.selectedReason)
        } else {
            this.showValidationError = true
        }
    }

    onReasonSelected(reason: BookingReason) {
        this.selectedReason = reason
        this.showValidationError = false
    }
}
